export const COLUMN_NAMES = {
    ID: 'id',
    PAGENAME: 'pagename',
    PARAM: 'param',
    ACTIONS: 'actions',
};
